import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild
} from '@angular/core';

export type ConfirmationResult = 'yes' | 'no' | 'cancel';

@Component({
  selector: 'confirmation-modal',
  templateUrl: './confirmation-modal.component.html',
  styleUrls: ['./confirmation-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ConfirmationModalComponent implements AfterViewInit {
  @Input() open = false;
  @Input() title = 'Confirm';
  @Input() confirmLabel = 'Yes';
  @Input() cancelLabel = 'Cancel';
  @Input() message: string | null = null;
  @Input() sponsor: string | null = null;
  @Output() closed = new EventEmitter<ConfirmationResult>();

  @ViewChild('firstFocusable') firstFocusable?: ElementRef<HTMLButtonElement>;

  ngAfterViewInit(): void {
    this.tryFocus();
  }

  onBackdrop(): void {
    this.closed.emit('cancel');
  }
  onCancel(): void {
    this.closed.emit('no');
  }
  onConfirm(): void {
    this.closed.emit('yes');
  }

  private tryFocus(): void {
    if (this.open && this.firstFocusable?.nativeElement) {
      requestAnimationFrame(() => this.firstFocusable!.nativeElement.focus());
    }
  }
}
